import { LogErrors } from './../LogErrors'

import { DoubleAttempt } from './Helpers/DoubleAttempt'


/**
 * Realiza la llamada a la API para registrar los datos de confirmación.
 * @param {Object} formData Información del formulario { name, lastName, alias, email, password }
 * @returns {Object} Resultado del proceso { success: boolean, data: Object, message: string }
 */
const Confirms = async (token, formData) => {
  try {
    const dataToSend = {
      user: {
        name: formData.name,
        lastName: formData.lastName,
        nickname: formData.nickname,
        email: formData.email,
        password: formData.password
      }
    }
    
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: JSON.stringify(dataToSend),
    }

    const url = process.env.REACT_APP_API_URL + '/api/Api/Confirm'

    const response = await DoubleAttempt(url, parameters, false)

    if (response.success) {
        return { success: true, data: response.data }
    } else {
        return { success: false, message: response.message }
    }

    // const response = await fetch(process.env.REACT_APP_API_URL + '/api/Api/Confirm', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': token
    //   },
    //   body: JSON.stringify(dataToSend),
    // })
    
    // if (!response.ok) {
    //   // Manejar errores HTTP
    //   const errorData = await response.json()
    //   return { success: false, message: errorData.message } //errorCode
    // }
    
    // // Retornar la respuesta exitosa
    // return { success: true, data: null }
  } catch (error) {
    await LogErrors('Confirms - DL Confirms', error)
    //return { success: false, message: 'errorNetwork' } // Código genérico para errores de red
    return { success: false, message: 2 }
  }
}

export { Confirms };